import domain from "./domain";

export const resetWorkspaceBilling = domain.createEvent('resetWorkspaceBilling');
